module.exports = __webpack_public_path__ + "static/hero-hcp-home-224184f8b0e170322d9707ed38bbdae2.png";